module.exports = __webpack_public_path__ + "static/media/hollow_bar_prewash10_tall.7038cee3.svg";